import * as React from "react";
import { TableModel, SortingOrder, ColumnType } from "./TableModel.js";
import { TableView } from "./TableView.jsx";
export { Table, TableModel, TableView, SortingOrder, ColumnType };
/**
 * Компонент Таблица.
 * @param {TableModel} props - Атрибуты элемента.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Table(props) {
  const [model, updateModel] = React.useState(new TableModel(props));
  React.useEffect(() => {
    updateModel(new TableModel(props));
  }, [props]);
  for (const column of model.columns)
    if (column.sortable)
      column.onSort = (event) => {
        event.preventDefault();
        model.toggleSort(column);
        updateModel(new TableModel(model));
      };
  return <TableView model={model} />;
}
